import vueComponentOptions from 'components/InputTextArea.vue';

const TextAreaInput = Vue.extend(vueComponentOptions);

module.exports = TextAreaInput;
